import { useTranslation } from 'react-i18next';
import { RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_ENGAGEMENT_RATE, MAX_ENGAGEMENT_RATE, MIN_MAX_EN_RATE_OPTIONS } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const EngagementRateField = () => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      options={MIN_MAX_EN_RATE_OPTIONS}
      title={t('General.Engagement Rate')}
      slideProps={{ step: 0.1, min: MIN_ENGAGEMENT_RATE, max: MAX_ENGAGEMENT_RATE }}
      minField={{ placeholder: `${MIN_ENGAGEMENT_RATE}%`, name: 'minEngagementRate' }}
      maxField={{ placeholder: `${MAX_ENGAGEMENT_RATE}%`, name: 'maxEngagementRate' }}
    />
  );
};
